module.exports = require('./dist').default



//////////////////
// WEBPACK FOOTER
// ./node_modules/yaml/browser/index.js
// module id = 1884
// module chunks = 0